"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
function convertSToMS(durationSec) {
    return lodash_1.isNumber(durationSec) && lodash_1.isFinite(durationSec)
        ? lodash_1.ceil(durationSec * 1000)
        : null;
}
exports.convertSToMS = convertSToMS;
//# sourceMappingURL=time.js.map